import { createRouter, createWebHistory } from 'vue-router'

import LoginView from '../views/LoginView.vue'
import RegistrationView from '../views/RegistrationView.vue'
import ForgotView from '../views/ForgotView.vue'
import MainView from '../views/MainView.vue'
import CatalogView from '../views/CatalogView.vue'
import CatalogSectionView from "@/views/CatalogSectionView";
import CatalogProductView from "@/views/CatalogProductView";
import FavoriteView from "@/views/FavoriteView";
import BasketView from "@/views/BasketView";
import OrderView from "@/views/OrderView";
import OrderFinishView from "@/views/OrderFinishView";
import MyOrdersView from "@/views/MyOrdersView";
import OrderDetailView from "@/views/OrderDetailView";
import MutualSettlementsView from "@/views/MutualSettlementsView";
import CalculationsView from "@/views/CalculationsView";
import DocumentsView from "@/views/DocumentsView";
import OfferView from "@/views/OfferView";
import PrivacyPolicyView from "@/views/PrivacyPolicyView";

const routes = [
  {
    path: '/lk/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/lk/registration',
    name: 'registration',
    component: RegistrationView
  },
  {
    path: '/lk/forgot',
    name: 'forgot',
    component: ForgotView
  },
  {
    path: '/lk/:tab',
    name: 'main',
    component: MainView
  },
  {
    path: '/lk/catalog',
    name: 'catalog',
    component: CatalogView
  },
  {
    path: '/lk/catalog/:section',
    name: 'catalog_section',
    component: CatalogSectionView
  },
  {
    path: '/lk/catalog/:section/:product',
    name: 'catalog_product',
    component: CatalogProductView
  },
  {
    path: '/lk/favorite',
    name: 'favorite',
    component: FavoriteView
  },
  {
    path: '/lk/basket',
    name: 'basket',
    component: BasketView
  },
  {
    path: '/lk/order',
    name: 'order',
    component: OrderView
  },
  {
    path: '/lk/order/finish',
    name: 'order_finish',
    component: OrderFinishView
  },
  {
    path: '/lk/orders',
    name: 'orders',
    component: MyOrdersView
  },
  {
    path: '/lk/orders/:order_id',
    name: 'order_detail',
    component: OrderDetailView
  },
  {
    path: '/lk/mutual-settlement',
    name: 'mutual_settlements',
    component: MutualSettlementsView
  },
  {
    path: '/lk/mutual-settlement/calc',
    name: 'calc',
    component: CalculationsView
  },
  {
    path: '/lk/mutual-settlement/documents',
    name: 'documents',
    component: DocumentsView
  },
  {
    path: '/lk/offer',
    name: 'offer',
    component: OfferView
  },
  {
    path: '/lk/privacy-policy',
    name: 'privacy_policy',
    component: PrivacyPolicyView
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
